import {
	GET_PORTER_TRACKING,
	GET_PORTER_TRACKING_LOADING,
	GET_PORTER_TRACKING_ERROR,
} from "./actionTypes";

const initialState = {
	loading: false,
	error: null,
	data: null,
	cached: false,
	lastFetchedAt: null,
};

const porterTrackingReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_PORTER_TRACKING_LOADING:
			return {
				...state,
				loading: action.payload,
			};
		case GET_PORTER_TRACKING:
			return {
				...state,
				loading: false,
				error: null,
				data: action.payload.data,
				cached: action.payload.cached,
				lastFetchedAt: action.payload.lastFetchedAt,
			};
		case GET_PORTER_TRACKING_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error,
				message: action.payload.message,
				data: action.payload.data,
			};
		default:
			return state;
	}
};

export default porterTrackingReducer;
